import { devtools, persist } from "zustand/middleware"
import { shallow } from "zustand/shallow"
import { createWithEqualityFn } from "zustand/traditional"

import type { FeaturesStore } from "../store.interfaces"

export const useFeaturesStore = createWithEqualityFn<FeaturesStore>()(
  persist(
    devtools(
      (set) => ({
        features: null,
        setFeatures: (features) => set({ features }),
      }),
      { name: "FeaturesStore" }
    ),
    {
      name: "features-store",
      getStorage: () => localStorage,
    }
  ),
  shallow
)
